var map = {
	"./Alert01.wav": 88638,
	"./Alert02.wav": 50281,
	"./Screaming_Goat.mp3": 73590,
	"./camera-click.mp3": 41917,
	"./likeSound.mp3": 88683,
	"./loud_alarm.mp3": 18557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88285;